import {Record} from 'immutable';

import type {PricedProductBooking, BookingStatus} from 'web-app/util/graphql/api-types';

import {type MonthlyPrice, type BookingType} from './session-booking';

interface IProductBooking {
    readonly bookingType: BookingType;
    readonly day: string;
    readonly productId: string;
    readonly productVersion: string;
    readonly monthlyPrices: MonthlyPrice[];
    readonly amount: number;
    readonly bookedPrice: string | null;
    readonly planRuleId: string | null;
    readonly bookingStatus: BookingStatus | null;
    readonly isVirtual: boolean | null;
}

export class ProductBooking extends Record<IProductBooking>({
    bookingType: 'ProductBooking',
    day: '',
    productId: '',
    monthlyPrices: [],
    productVersion: '',
    amount: 0,
    bookedPrice: null,
    planRuleId: null,
    bookingStatus: null,
    isVirtual: false,
}) {}

const fromAPI = (data: any) => {
    return new ProductBooking({
        ...data,
    });
};

const fromGraphQL = (data: PricedProductBooking) =>
    new ProductBooking({
        day: data.productAvailability.day,
        productId: data.productAvailability.product.productId,
        monthlyPrices: data.prices.map(price => ({
            price: Number.parseFloat(price.price),
            pricingGroupId: price.pricingGroupId,
        })),
        productVersion: data.productAvailability.product.productVersionId,
        amount: data.amount,
        bookedPrice: data.bookedPrice,
        planRuleId: data.planRuleId,
        bookingStatus: data.bookingStatus,
        isVirtual: data?.isVirtual ?? false,
    });

export default {
    record: ProductBooking,
    default: new ProductBooking(),
    fromAPI,
    fromGraphQL,
};
